import {inject, provideAppInitializer} from '@angular/core';
import {OauthFlowService} from './oauth-flow.service';
import {WINDOW_TOKEN} from '../core/tokens/window.token';

export const provideAuthConfigInit = provideAppInitializer(() => {
  const flowService = inject(OauthFlowService);
  const window = inject(WINDOW_TOKEN);
  const clientId = import.meta.env.NG_APP_CLIENT_ID;
  const authorizationEndpoint = import.meta.env.NG_APP_AUTHORIZATION_ENDPOINT;
  const tokenEndpoint = import.meta.env.NG_APP_TOKEN_ENDPOINT;
  const logoutEndpoint = import.meta.env.NG_APP_LOGOUT_ENDPOINT;
  const redirectUri = window.location.origin + '/auth/callback';
  const postLogoutRedirectUri = window.location.origin + '/';

  flowService.configure({
    clientId,
    redirectUri,
    authorizationEndpoint,
    tokenEndpoint,
    logoutEndpoint,
    postLogoutRedirectUri,
    refreshEnabled: true,
    refreshBufferSeconds: 60,
    requestedScopes: 'openid profile email offline_access'
  });
});
